import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import UseAuthConfig from './useAuthConfig';

interface Params {
  accessToken: string;
  url: string;
}

const useUserParams = (index: number): Params | null => {
  const location = useLocation();
  const id = location.pathname.split("/")[index];
  const { protectedResources }: any = UseAuthConfig();

  useEffect(() => {
    if (!id) {
      console.error('User id not found in pathname');
    }
  }, [id, index]);

  const params: Params | null = id ? {
    accessToken: localStorage.getItem('AccessToken') || "",
    url: `${protectedResources.apiTodoList.endpoint}/users/${id}`,
  } : null;

  return params;
};

export default useUserParams;
